module.exports = __webpack_public_path__ + "static/media/kim-semenza-resume.41862526.pdf";